import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { dateToLocaleStringFull } from 'app/libs/helpers';
import classes from 'app/containers/Notifications/Notification/Notification.module.scss';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { functionsByContentType, getActionObjectTypeIdentifier, redirectAction } from 'app/core/utils/contentTypesUtils';
import { MUIButton } from 'app/components/Form';
import settings from 'app/core/settings';
import { useSelector } from 'react-redux';
import { projectConfigDataSelector } from 'app/store/selectors/serverConfig';
const Notification = ({ notification, isLastNotif, onClickNotif }) => {
    const config = useSelector(projectConfigDataSelector);
    const dateToString = () => {
        const { timestamp } = notification.actionInst;
        return dateToLocaleStringFull(new Date(timestamp));
    };
    const handleClickNotif = (event) => {
        if ((onClickNotif && event.button === 0) || event.button === 1) {
            onClickNotif(notification);
        }
    };
    const renderXLSLDownload = () => {
        var _a, _b;
        const { actionInst } = notification;
        const className = cx(classes.container, {
            [classes.isLastNotif]: isLastNotif,
            [classes.isRead]: !notification.unread,
        });
        return (_jsxs("div", { className: `${className} flex row alignCenter cursor`, onClick: handleClickNotif, children: [_jsx("div", { style: { color: 'grey', fontSize: 28, margin: '10px 20px' }, children: _jsx(FontIcon, { icon: "fas-file-excel" }) }), _jsxs("div", { className: "flex column", children: [_jsx("div", { className: classes.title, children: functionsByContentType[getActionObjectTypeIdentifier(actionInst.actionObjectType, actionInst.verb, config)].labelNotif(notification) }), _jsx("div", { className: classes.notifDate, children: dateToString() })] }), _jsx("a", { href: `${settings.env.EXPORT_API_URL}/${(_a = actionInst.datas) === null || _a === void 0 ? void 0 : _a.fileName}`, download: (_b = actionInst.datas) === null || _b === void 0 ? void 0 : _b.fileName, target: "_blank", rel: "noreferrer noopener", style: { margin: '10px 20px 10px auto' }, children: _jsx(MUIButton, { icon: "fas-save", style: { height: 40, width: 40, fontSize: 20 }, tooltip: "Download", variant: "text", size: "large" }) })] }));
    };
    const { actionInst } = notification;
    const { verb } = actionInst;
    if (verb === 'xlslExport')
        return renderXLSLDownload();
    const className = cx(classes.container, {
        [classes.isLastNotif]: isLastNotif,
        [classes.isRead]: !notification.unread,
    });
    return (
    // TODO add icon for each type of notif
    _jsxs(Link, { className: className, to: redirectAction(notification, { getPath: true }), onClick: handleClickNotif, children: [_jsx("div", { className: classes.title, children: functionsByContentType[getActionObjectTypeIdentifier(actionInst.actionObjectType, actionInst.verb)].labelNotif(notification) }), _jsx("div", { className: classes.notifDate, children: dateToString() })] }));
};
export default Notification;
